<template>
  <div class="switcher-wrapper">
    <div class="checkbox">
      <label>
        <input
          :class="{checked: value}"
          type="checkbox"
          v-bind:value="value"
          @change="$emit('input', $event.target.checked)"
          :name="name"
          :checked="value"  />
        <span class="switcher-circle"></span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Switcher',
  props: ['value', 'name']
}
</script>

<style lang="scss" scoped>
  .switcher-wrapper {
    display: inline-block;
    cursor: pointer;
  }

  .switcher-wrapper input[type=checkbox] {
    visibility: hidden;
    display: none;
  }

  .checkbox {
    width: 30px;
    height: 8px;
    background: #555;
    position: relative;
    border-radius: 3px;
  }

  .checkbox label {
    width: 30px;
    height: 9px;
    margin-top: -16px;
    cursor: pointer;
  }

  .checkbox label .switcher-circle {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    transition: all .5s ease;
    cursor: pointer;
    position: absolute;
    top: -3px;
    left: -3px;
    background: #ccc;
  }
  .checkbox input[type=checkbox]:checked + .switcher-circle {
    left: 24px;
    background: #F68D2E;
  }
  .checkbox-wrapper {
    display: block;
    float: left;
    margin-top: 8px;
    padding-left: 3px;
  }
  .checkbox-text {
    width: 85%;
    display: block;
    float: left;
    text-align: left;
  }
</style>
